import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { Beat } from "../../plugins/spinners.plugin";
import Input from "../inputs/inputs";
import Button from "../buttons/buttons";
//images
import CLOSE from "../../assets/images/icons/close.svg";
//Api
import { isAuthenticatedUser } from "../../utils/Auth";
import {
  updateAnAddressAction,
  getMyAddressesAction,
} from "../../redux/address/addressActions";

export function AddDeliveryInstructionModal(props) {
  const { currentAddress } = props;
  const dispatch = useDispatch();
  const isAuth = isAuthenticatedUser();
  const { processing } = useSelector((state) => state.address);
  const [deliveryNotes, setDeliveryNotes] = useState(
    currentAddress?.description || ""
  );

  // Reset to current address description when modal opens or address changes
  useEffect(() => {
    if (props.show) {
      setDeliveryNotes(currentAddress?.description || "");
    }
  }, [props.show, currentAddress]);

  const handleChange = (e) => {
    setDeliveryNotes(e.target.value);
  };

  const handleAddressDeliveryNotes = async () => {
    if (currentAddress?.length > 0 && deliveryNotes.length > 3) {
      try {
        const response = await dispatch(
          updateAnAddressAction({
            id: currentAddress?.id,
            description: deliveryNotes,
          })
        );
        if (response) {
          // Refresh addresses to show updated delivery notes
          await dispatch(getMyAddressesAction());
          props.onClose();
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  return (
    <div data-test="addressModal">
      <Transition show={props.show} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-[650px] bg-white dark:bg-[#121212] rounded-3xl px-4 pt-5 pb-4 max-h-[90vh] h-full overflow-scroll shadow-xl transform transition-all sm:my-10 sm:max-w-lg sm:w-full  sm:p-8">
                  <div className="sm:block absolute top-1 sm:top-3 right-4 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-[#ffeae5] rounded-3xl p-2 sm:p-3 outline-none"
                      onClick={props.onClose}
                    >
                      <span className="sr-only">Close</span>
                      <img
                        src={CLOSE}
                        alt="close"
                        className=" w-3 h-3 sm:w-4 sm:h-4"
                      />
                    </button>
                  </div>
                  <div className="sm:flex">
                    <div className="text-left sm:mt-2">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-medium text-black dark:text-white"
                      >
                        Delivery Instructions
                      </Dialog.Title>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4">
                    <div className="mt-4 border-b-2 "></div>
                    <div className="mt-8">
                      {!isAuth ? (
                        <div className="text-center py-8">
                          <p className="text-gray-500 dark:text-[#BCBCBC]">
                            Please login to add delivery instructions
                          </p>
                        </div>
                      ) : !currentAddress || currentAddress?.length === 0 ? (
                        <div className="text-center py-8">
                          <p className="text-gray-500 dark:text-[#BCBCBC]">
                            Please set a delivery address first to add
                            instructions
                          </p>
                        </div>
                      ) : (
                        <div>
                          <Input.Label
                            title={"Delivery Instructions"}
                            type={"text"}
                            name={"description"}
                            placeholder={`E.g door or apartment number...`}
                            onChange={handleChange}
                            value={deliveryNotes}
                            className="mb-12"
                          />

                          <Button.Primary
                            type="button"
                            disabled={processing || deliveryNotes.length < 4}
                            className="bg-primary text-white w-full h-12 rounded-lg"
                            title={
                              processing ? (
                                <Beat />
                              ) : currentAddress?.description ? (
                                "Update Note"
                              ) : (
                                "Add Note"
                              )
                            }
                            onClick={handleAddressDeliveryNotes}
                          />
                        </div>
                      )}

                      <Button.Secondary
                        type="button"
                        className="w-full h-12 rounded-lg mt-5"
                        title={"Cancel"}
                        onClick={props.onClose}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
